"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.asyncGroupLectureVideos = exports.getSchedule = exports.asyncGetSchedule = void 0;
function asyncGetSchedule(course, useCache = false) {
    const registry = [];
    // Add lectures
    let lectureKey = useCache === true ? 'lecturesMetaData' : 'lectures';
    course.subjects.forEach((subject) => {
        // @ts-ignore
        subject[lectureKey].forEach((lecture) => {
            lecture.topicLabel = subject.title;
            registry.push({
                type: 'lecture',
                days: (() => {
                    if (subject.lectureDaySchedulePlan) {
                        if (Array.isArray(subject.lectureDaySchedulePlan[lecture._id])) {
                            return subject.lectureDaySchedulePlan[lecture._id];
                        }
                    }
                    return [];
                })(),
                data: lecture
            });
        });
    });
    // Add exams
    if (Array.isArray(course.exams)) {
        let examKey = useCache === true ? 'examCache' : 'exams';
        course.exams.forEach((examLink) => registry.push({
            type: 'exam',
            days: examLink.dayTags,
            // @ts-ignore
            data: Object.assign({}, examLink[examKey], {
                _id: (typeof examLink.exam === 'string' ? examLink.exam : null)
            })
        }));
    }
    let result = registry.reduce((accumulator, item) => {
        item.days.forEach((day) => {
            let dayEntry = accumulator.find((a) => a.dayIndex === day);
            if (!dayEntry) {
                dayEntry = {
                    dayIndex: day,
                    exams: [],
                    lectures: [],
                    title: `Day ${day}`
                };
                accumulator.push(dayEntry);
            }
            if (item.type === 'exam') {
                dayEntry.exams.push(item.data);
            }
            else if (item.type === 'lecture') {
                dayEntry.lectures.push(item.data);
            }
        });
        return accumulator;
    }, []);
    result = result.sort((a, b) => {
        if (a.dayIndex > b.dayIndex) {
            return 1;
        }
        return -1;
    });
    return result;
}
exports.asyncGetSchedule = asyncGetSchedule;
function getSchedule(course) {
    return new Promise((resolve, reject) => {
        resolve(asyncGetSchedule(course));
    });
}
exports.getSchedule = getSchedule;
function asyncGroupLectureVideos(course, useCache = false) {
    course.subjects.map((subject) => {
        subject.lectureTopicMetadata = subject.lectureTopicMetadata || {};
        let lectureKey = useCache === true ? 'lecturesMetaData' : 'lectures';
        // @ts-ignore
        subject.groupView = subject[lectureKey].reduce((accumulator, item) => {
            let groupTitle = subject.lectureTopicMetadata[item._id];
            if (!groupTitle || groupTitle === '') {
                groupTitle = subject.title;
            }
            let section = accumulator.find((g) => g.groupTitle === groupTitle);
            if (!section) {
                section = {
                    groupTitle: groupTitle,
                    lecture: []
                };
                accumulator.push(section);
            }
            section.lecture.push(item);
            return accumulator;
        }, []);
    });
    return course;
}
exports.asyncGroupLectureVideos = asyncGroupLectureVideos;
//# sourceMappingURL=course.js.map